var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingShow)?_c('div',{staticClass:"common-loading"},[_c('img',{attrs:{"src":require("./images/loading.gif")}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }